// hack for babel-plugin-component

export { default } from '../utils/bind-env';



// WEBPACK FOOTER //
// ./packages/bind-env/index.js